import { isPrivate } from 'src/common/config';

let envGateWayDomain = 'https://gateway.qidian.qq.com';
if(isPrivate) {
    envGateWayDomain = '';
} else if (/^oa/.test(window.location.host)) {
    envGateWayDomain = 'https://testgateway.qidian.qq.com';
} else if (/^local/.test(window.location.host)) {
    envGateWayDomain = '';
}

function getReqFun(methodName, transParams) {
    const reqFun = function(url, postData = {}, config = {}) {
        return new Promise((resolve, reject) => {
            const reqData = postData && {...postData};
            const { originRes, errLevel = 0 } = config || {};

            if(transParams) {
                reqData.params = postData;
            }

            Vue.prototype.$ajax[methodName](`${envGateWayDomain}${url}`, reqData)
                .then(res => {
                    const { code, message, data } = res || {};

                    if (originRes) {
                        resolve(res);
                    } else {
                        if (parseInt(code, 10) === 0) {
                            resolve(data);
                        } else {
                            if(errLevel === 1){
                                reject(res);
                            }else {
                                reject(message);
                            }
                        }
                    }
                })
                .catch(err => {
                    if (originRes) {
                        reject(err);
                    } else {
                        const { message } = err || {};
                        if(errLevel === 1){
                            reject(err);
                        }else {
                            reject(message);
                        }
                    }
                });
        });
    };

    return reqFun;
}

export default {
    domain: envGateWayDomain,
    get: getReqFun('crossGet', true),
    post: getReqFun('crossPost')
};
